<div class="alinea-derecha">
    <a
        class="btn-voltar-page ng-star-inserted"
        href="javascript:void(0)"
        (click)="goBack()">
        <i aria-hidden="true" class="fa fa-arrow-left"></i>
    </a>
</div>
